import { render, staticRenderFns } from "./ActivateAccountPage.vue?vue&type=template&id=32733d7a&scoped=true"
import script from "./ActivateAccountPage.vue?vue&type=script&lang=js"
export * from "./ActivateAccountPage.vue?vue&type=script&lang=js"
import style0 from "./ActivateAccountPage.vue?vue&type=style&index=0&id=32733d7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32733d7a",
  null
  
)

export default component.exports